import {
    canSeeAbsenceTypesSection,
    canSeeProjectTypesSection,
    canSeeShiftTypesSection,
    canSeeTagTypesSection,
} from '../../features/profile/entityPermissions';
import { Profile } from '../../features/profile/types';
import { NAVIGATION_ROUTES } from '../../routes/NavigationRoute';

export type TypeTabKey = 'project' | 'shift' | 'absence' | 'tag';

export interface TypeTabDefinition {
    key: TypeTabKey;
    label: string;
    path: string;
}

type LegacyPermissionsMap = Partial<Record<TypeTabKey, string[]>>;

const TYPE_TABS: TypeTabDefinition[] = [
    { key: 'project', label: 'Project', path: NAVIGATION_ROUTES.PROJECT_TYPES },
    { key: 'shift', label: 'Shift', path: NAVIGATION_ROUTES.SHIFT_TYPES },
    { key: 'absence', label: 'Absence', path: NAVIGATION_ROUTES.ABSENCE_TYPES },
    { key: 'tag', label: 'Tag', path: NAVIGATION_ROUTES.TAG_TYPES },
];

export function getVisibleTypeTabs(
    profile: Profile | null | undefined,
    legacyPermissions: LegacyPermissionsMap = {}
): TypeTabDefinition[] {
    return TYPE_TABS.filter((tab) => {
        switch (tab.key) {
            case 'project':
                return canSeeProjectTypesSection(profile, legacyPermissions.project);
            case 'shift':
                return canSeeShiftTypesSection(profile, legacyPermissions.shift);
            case 'absence':
                return canSeeAbsenceTypesSection(profile, legacyPermissions.absence);
            case 'tag':
                return canSeeTagTypesSection(profile, legacyPermissions.tag);
            default:
                return false;
        }
    });
}
